import { Controller } from "@hotwired/stimulus"
import { track as mixpanelTrack } from "../lib/mixpanel"

// Phase 2.5 Tier 2 — project Funding sub-tab. Allocate / reserve /
// release modals with backdrop dismiss + stopPropagation. Pulls reserve
// / release URL from each row's data attributes.
export default class extends Controller {
  static targets = [
    "allocateModal",
    "reserveModal", "reserveForm", "reserveFund",
    "releaseModal", "releaseForm", "releaseFund"
  ]
  static values = { projectId: Number }

  showAllocateModal() {
    this._show(this.allocateModalTarget)
    if (this.projectIdValue) {
      mixpanelTrack("Project Funding Allocate Modal Opened", {
        project_id: this.projectIdValue
      })
    }
  }

  hideAllocateModal() { this._hide(this.allocateModalTarget) }

  showReserveModal(event) {
    const trigger = event.currentTarget
    this.reserveFormTarget.action = trigger.dataset.allocationReserveUrl || ""
    if (this.hasReserveFundTarget) {
      const fund = trigger.dataset.allocationFund || ""
      this.reserveFundTarget.textContent = fund ? `— ${fund}` : ""
    }
    this._show(this.reserveModalTarget)
  }

  hideReserveModal() { this._hide(this.reserveModalTarget) }

  showReleaseModal(event) {
    const trigger = event.currentTarget
    this.releaseFormTarget.action = trigger.dataset.allocationReleaseUrl || ""
    if (this.hasReleaseFundTarget) {
      const fund = trigger.dataset.allocationFund || ""
      this.releaseFundTarget.textContent = fund ? `— ${fund}` : ""
    }
    this._show(this.releaseModalTarget)
  }

  hideReleaseModal() { this._hide(this.releaseModalTarget) }

  stopPropagation(event) { event.stopPropagation() }

  _show(modal) {
    if (!modal) return
    modal.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  _hide(modal) {
    if (!modal) return
    modal.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
